import React from 'react';

import { useTranslation } from 'providers/GILT.provider';

const TextDeposit = () => {
  const { t } = useTranslation();

  return (
    <div data-bem="TextDeposit">
      <div className="bottom-text">
        <span>{t('clientConnect.sectionsDescriptionPart1')}</span> {t('clientConnect.section2Description2Part2')}
      </div>
    </div>
  );
};

export default TextDeposit;
